"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withScriptjs = _interopRequireDefault(require("react-google-maps/lib/withScriptjs"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var WithGoogleMapScript = function WithGoogleMapScript() {
  return function (WrappedComponent) {
    var Component = (0, _withScriptjs["default"])(WrappedComponent);

    var WithGoogleMap = function WithGoogleMap(props) {
      return _react["default"].createElement(Component, _extends({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?libraries=places,geometry&key=".concat(process.env.REACT_APP_GMAPS_API_KEY),
        loadingElement: _react["default"].createElement("div", {
          style: {
            height: "100%"
          }
        })
      }, props));
    };

    return WithGoogleMap;
  };
};

var _default = WithGoogleMapScript;
exports["default"] = _default;